// framework
import React, { useEffect, useState, useCallback } from "react";
import { audio } from 'services/audioManager';

// styles
import styles from "./OptionsMenu.module.scss";

// components
import ErrorModal from "components/Utility/ErrorModal";

// constants
import { MESSAGES, NON_RESTARTABLE_STATES } from "constants/constants";

// Define action configurations at the top of the component
const LEAVE_ACTIONS = {
    end: {
        message: MESSAGES.TO_SERVER.CALL_END_GAME,
        confirmTitle: "Are you sure you want to end the current game?",
        confirmButton: "End Game"
    },
    lobby: {
        message: MESSAGES.TO_SERVER.CHANGE_GAME,
        confirmTitle: "Are you sure you want to return to the Game.City Lobby?",
        confirmButton: "Go To Lobby"
    },
    self: {
        handler: (room) => room.leave(),
        confirmTitle: "Are you sure you want to leave the game, your progress will be lost?",
        confirmButton: "Leave Game"
    }
};

export default function OptionsMenu({ room, menuOpen, toggleMenu, mutedMusic, mutedSfx, gameState, isPrimaryPlayer, isHost }) {

    const [showConfirmLeave, setShowConfirmLeave] = useState(false);
    const [confirmLeaveAction, setConfirmLeaveAction] = useState(null); // "end" | "lobby"

    // Mute/unmute music when the prop changes
    useEffect(() => {
        if (!isHost || mutedMusic === undefined) return;
        audio.muteMusic(mutedMusic);
    }, [isHost, mutedMusic]);

    // Mute/unmute sfx when the prop changes
    useEffect(() => {
        if (!isHost || mutedSfx === undefined) return;
        audio.muteSfx(mutedSfx);
        audio.muteVo(mutedSfx);
    }, [isHost, mutedSfx]);

    // Close confirm dialog if the game state changes while it's open
    useEffect(() => {
        if (showConfirmLeave) {
            setShowConfirmLeave(false);
            setConfirmLeaveAction(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gameState]);

    const handleConfirmLeave = useCallback((action) => {
        setShowConfirmLeave(true);
        setConfirmLeaveAction(action);
    }, []);

    const closeConfirmLeave = useCallback(() => {
        setShowConfirmLeave(false);
        setConfirmLeaveAction(null);
    }, []);

    const doLeaveAction = useCallback(() => {
        console.log("Action confirmed: ", confirmLeaveAction);
        const action = LEAVE_ACTIONS[confirmLeaveAction];

        if (action) {
            if (action.handler) {
                action.handler(room);
            } else if (action.message) {
                room.send(action.message, {});
            }
        }

        toggleMenu();
        closeConfirmLeave();
    }, [confirmLeaveAction, room, toggleMenu, closeConfirmLeave]);

    const toggleMuteMusic = useCallback(() => {
        console.log("Calling mute_game_music: ", !mutedMusic);
        room.send(MESSAGES.TO_SERVER.MUTE_MUSIC, { mute: !mutedMusic });
    }, [room, mutedMusic]);

    const toggleMuteSfx = useCallback(() => {
        console.log("Calling mute_game_sfx: ", !mutedSfx);
        room.send(MESSAGES.TO_SERVER.MUTE_SFX, { mute: !mutedSfx });
    }, [room, mutedSfx]);

    const hasVipControls = true; // const hasVipControls = isPrimaryPlayer || isHost;
    //const canRestartGame = gameState !== undefined && !NON_RESTARTABLE_STATES.includes(gameState);

    return (
        <div className={`${styles.menuContainer} ${menuOpen ? styles.open : ""} `}>
            <div className={`${styles.menuSection} ${menuOpen ? styles.open : ""}`}>
                <div className={styles.spacer} />
                <div className={styles.button} onClick={toggleMuteMusic}>
                    {mutedMusic ? "Unmute Music" : "Mute Music"}
                </div>
                <div className={styles.spacer} />
                <div className={styles.button} onClick={toggleMuteSfx}>
                    {mutedSfx ? "Unmute Sound Effects" : "Mute Sound Effects"}
                </div>
                <div className={styles.spacer} />
                <div className={styles.button} onClick={hasVipControls ? () => handleConfirmLeave("lobby") : undefined} style={{ opacity: hasVipControls ? 1 : 0.5, pointerEvents: hasVipControls ? "auto" : "none", }} >
                    Go To Lobby
                    {!hasVipControls && (
                        <span className={styles.vipLabel}> (Only VIP)</span>
                    )}
                </div>
                <div className={styles.spacer} />
                {/*{canRestartGame && <>*/}
                {/*        <div className={styles.button} onClick={hasVipControls ? () => handleConfirmLeave("end") : undefined} style={{ opacity: hasVipControls ? 1 : 0.5, pointerEvents: hasVipControls ? "auto" : "none", }} >*/}
                {/*            Restart Game*/}
                {/*            {!hasVipControls && (*/}
                {/*                <span className={styles.vipLabel}> (Only VIP)</span>*/}
                {/*            )}*/}
                {/*        </div>*/}
                {/*        <div className={styles.spacer} />*/}
                {/*    </>*/}
                {/*}*/}

                {/*{!isHost && <>*/}
                {/*        <div className={styles.button} onClick={() => handleConfirmLeave("self")}>*/}
                {/*            Dissconnect*/}
                {/*        </div>*/}
                {/*        <div className={styles.spacer} />*/}
                {/*    </>*/}
                {/*}*/}
                {/* {!isHost && (
                      <>
                        <div className={styles.button} onClick={onChangeName}>
                          Change Name
                        </div>
                        <div className={styles.spacer} />
                      </>
                    )} */}
                <div className={styles.button} onClick={toggleMenu}>
                    Close
                </div>
                <div className={styles.spacer} />
            </div>

            {showConfirmLeave && (
                <ErrorModal
                    title="Are you sure?"
                    message={LEAVE_ACTIONS[confirmLeaveAction]?.confirmTitle}
                    callback={closeConfirmLeave}
                    callbackText="Cancel"
                    callback2={doLeaveAction}
                    callbackText2={LEAVE_ACTIONS[confirmLeaveAction]?.confirmButton}
                />
            )}
        </div>
    );
}
